
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $bd1bdad34f04cd14$exports = {};
// check document first so it doesn't error in node.js
var $bd1bdad34f04cd14$var$style = typeof document != "undefined" ? document.createElement("p").style : {};
var $bd1bdad34f04cd14$var$prefixes = [
    "O",
    "ms",
    "Moz",
    "Webkit"
];
var $bd1bdad34f04cd14$var$upper = /([A-Z])/g;
var $bd1bdad34f04cd14$var$memo = {};
/**
 * prefix `key`
 *
 *   prefix('transform') // => WebkitTransform
 *
 * @param {String} key
 * @return {String}
 * @api public
 */ function $bd1bdad34f04cd14$var$prefix(key) {
    // Camel case
    key = key.replace(/-([a-z])/g, function(_, char) {
        return char.toUpperCase();
    });
    // Without prefix
    if ($bd1bdad34f04cd14$var$style[key] !== undefined) return key;
    // With prefix
    var Key = key.charAt(0).toUpperCase() + key.slice(1);
    var i = $bd1bdad34f04cd14$var$prefixes.length;
    while(i--){
        var name = $bd1bdad34f04cd14$var$prefixes[i] + Key;
        if ($bd1bdad34f04cd14$var$style[name] !== undefined) return name;
    }
    return key;
}
/**
 * Memoized version of `prefix`
 *
 * @param {String} key
 * @return {String}
 * @api public
 */ function $bd1bdad34f04cd14$var$prefixMemozied(key) {
    return key in $bd1bdad34f04cd14$var$memo ? $bd1bdad34f04cd14$var$memo[key] : $bd1bdad34f04cd14$var$memo[key] = $bd1bdad34f04cd14$var$prefix(key);
}
/**
 * Create a dashed prefix
 *
 * @param {String} key
 * @return {String}
 * @api public
 */ function $bd1bdad34f04cd14$var$prefixDashed(key) {
    key = $bd1bdad34f04cd14$var$prefix(key);
    if ($bd1bdad34f04cd14$var$upper.test(key)) {
        key = "-" + key.replace($bd1bdad34f04cd14$var$upper, "-$1");
        $bd1bdad34f04cd14$var$upper.lastIndex = 0;
    }
    return key.toLowerCase();
}
$bd1bdad34f04cd14$exports = $bd1bdad34f04cd14$var$prefixMemozied;
$bd1bdad34f04cd14$exports.dash = $bd1bdad34f04cd14$var$prefixDashed;


function $4eeceec2f456e43f$export$ccae322d238649b2(options, prefixes, element) {
    if (options.shadow) element.style[prefixes.boxShadow] = "0px 2.8px 2.2px rgba(0, 0, 0, 0.042), 0px 6.7px 5.3px rgba(0, 0, 0, 0.061), 0px 12.5px 10px rgba(0, 0, 0, 0.075), 0px 22.3px 17.9px rgba(0, 0, 0, 0.089), 0px 41.8px 33.4px rgba(0, 0, 0, 0.108), 0px 100px 80px rgba(0, 0, 0, 0.15)";
}


function $0062bc4b3dedcf35$export$c74eda7ed352dc6e(options, prefixes, element, shine) {
    if (options.shadow) element.style[prefixes.boxShadow] = "0px 2.2px 2.2px rgba(0, 0, 0, 0.02), 0px 5.3px 5.3px rgba(0, 0, 0, 0.028), 0px 10px 10px rgba(0, 0, 0, 0.035), 0px 17.9px 17.9px rgba(0, 0, 0, 0.042), 0px 33.4px 33.4px rgba(0, 0, 0, 0.05), 0px 80px 80px rgba(0, 0, 0, 0.07)";
    element.style[prefixes.transform] = "rotateX(0deg) rotateY(0deg)";
    if (options.shine) shine.style.opacity = 0;
}


function $ce29bd8005e13b89$export$f940502e6cd075ee(options, prefixes, element, parentElement, sensitivity, shine, event) {
    let parentElementWidth = parentElement.offsetWidth;
    let parentElementHeight = parentElement.offsetHeight;
    let ox;
    let oy;
    if (event.type === "touchmove") {
        event.preventDefault();
        let rect = element.getBoundingClientRect();
        ox = event.touches[0].clientX - rect.left;
        oy = event.touches[0].clientY - rect.top;
    } else {
        ox = event.offsetX;
        oy = event.offsetY;
    }
    let ax = options.invert ? -(parentElementWidth / 2 - ox) / sensitivity : (parentElementWidth / 2 - ox) / sensitivity;
    let ay = options.invert ? (parentElementHeight / 2 - oy) / sensitivity : -(parentElementHeight / 2 - oy) / sensitivity;
    let dy = oy - parentElementHeight / 2;
    let dx = ox - parentElementWidth / 2;
    let theta = Math.atan2(dy, dx);
    let ang = theta * (180 / Math.PI) - 90;
    let angle = ang < 0 ? ang + 360 : ang;
    if ("scale" in options) {
        if (options.scale) element.style[prefixes.transform] = `rotateY(${ax}deg) rotateX(${ay}deg) scale3d(${options.scale}, ${options.scale}, ${options.scale})`;
        else element.style[prefixes.transform] = `rotateY(${ax}deg) rotateX(${ay}deg)`;
    }
    if (options.shine) {
        shine.style.opacity = 1;
        shine.style.backgroundImage = `linear-gradient(${angle}deg, rgba(230, 230, 230, ${oy / parentElementHeight * 0.5}) 0%, transparent 80%)`;
    }
}


function $376065c23bd29606$export$2d87bb3ac19b3c3b(inputOptions = {}) {
    const defaultOptions = {
        targets: ".apps__container",
        perspective: 1000,
        sensitivity: 10,
        invert: false,
        scale: 0,
        shadow: false,
        shine: false,
        touch: false
    };
    const options = Object.assign({}, defaultOptions, inputOptions);
    const prefixes = {
        backfaceVisibility: (0, (/*@__PURE__*/$parcel$interopDefault($bd1bdad34f04cd14$exports)))("backfaceVisibility"),
        boxShadow: (0, (/*@__PURE__*/$parcel$interopDefault($bd1bdad34f04cd14$exports)))("boxShadow"),
        perspective: (0, (/*@__PURE__*/$parcel$interopDefault($bd1bdad34f04cd14$exports)))("perspective"),
        transformStyle: (0, (/*@__PURE__*/$parcel$interopDefault($bd1bdad34f04cd14$exports)))("transformStyle"),
        transform: (0, (/*@__PURE__*/$parcel$interopDefault($bd1bdad34f04cd14$exports)))("transform"),
        transitionDuration: (0, (/*@__PURE__*/$parcel$interopDefault($bd1bdad34f04cd14$exports)))("transitionDuration"),
        transitionProperty: (0, (/*@__PURE__*/$parcel$interopDefault($bd1bdad34f04cd14$exports)))("transitionProperty"),
        transitionTiming: (0, (/*@__PURE__*/$parcel$interopDefault($bd1bdad34f04cd14$exports)))("transitionTimingFunction"),
        userSelect: (0, (/*@__PURE__*/$parcel$interopDefault($bd1bdad34f04cd14$exports)))("userSelect"),
        willChange: (0, (/*@__PURE__*/$parcel$interopDefault($bd1bdad34f04cd14$exports)))("willChange")
    };
    const targets = document.querySelectorAll(options.targets);
    if (targets.length > 0) targets.forEach((target)=>{
        let targetParent = target.parentNode;
        let shine;
        let sensitivity = 0;
        const perspectiveValue = options.perspective && typeof options.perspective === "number" ? options.perspective + "px" : "1000px";
        targetParent.style[prefixes.perspective] = perspectiveValue;
        target.style[prefixes.perspective] = perspectiveValue;
        targetParent.style[prefixes.transformStyle] = "preserve-3d";
        targetParent.style[prefixes.userSelect] = "none";
        target.style[prefixes.transform] = "rotateY(0deg) rotateX(0deg)";
        target.style[prefixes.transformStyle] = "preserve-3d";
        target.style[prefixes.userSelect] = "none";
        sensitivity = options.sensitivity && typeof options.sensitivity === "number" ? options.sensitivity : 20;
        options.touch && (target.style[prefixes.backfaceVisibility] = "hidden");
        target.style.position = "relative";
        target.style[prefixes.transitionDuration] = "0.2s";
        target.style[prefixes.transitionProperty] = options.shadow ? "transform, box-shadow" : "transform";
        target.style[prefixes.transitionTiming] = "cubic-bezier(0.3, 1, 0.2, 1)";
        target.style[prefixes.willChangePrefix] = options.shadow ? "transform, box-shadow" : "transform";
        options.shadow && (target.style[prefixes.boxShadow] = "0px 2.2px 2.2px rgba(0, 0, 0, 0.02), 0px 5.3px 5.3px rgba(0, 0, 0, 0.028), 0px 10px 10px rgba(0, 0, 0, 0.035), 0px 17.9px 17.9px rgba(0, 0, 0, 0.042), 0px 33.4px 33.4px rgba(0, 0, 0, 0.05), 0px 80px 80px rgba(0, 0, 0, 0.07)");
        if (options.shine) {
            shine = document.createElement("div");
            shine.className = "apps__item__shine";
            shine.style.inset = 0;
            shine.style.opacity = 0;
            shine.style.position = "absolute";
            shine.style.zIndex = 9;
            shine.style[prefixes.transitionDuration] = "0.2s";
            shine.style[prefixes.transitionProperty] = "opacity";
            shine.style[prefixes.transitionTiming] = "cubic-bezier(0.3, 1, 0.2, 1)";
            shine.style[prefixes.willChange] = "opacity";
            target.appendChild(shine);
        }
        targetParent.addEventListener("mouseenter", function() {
            (0, $4eeceec2f456e43f$export$ccae322d238649b2)(options, prefixes, target);
        });
        targetParent.addEventListener("mousemove", function(event) {
            (0, $ce29bd8005e13b89$export$f940502e6cd075ee)(options, prefixes, target, targetParent, sensitivity, shine, event);
        });
        targetParent.addEventListener("mouseleave", function() {
            (0, $0062bc4b3dedcf35$export$c74eda7ed352dc6e)(options, prefixes, target, shine);
        });
        if (options.touch) {
            targetParent.addEventListener("touchstart", function() {
                (0, $4eeceec2f456e43f$export$ccae322d238649b2)(options, prefixes, target);
            });
            targetParent.addEventListener("touchmove", function(event) {
                (0, $ce29bd8005e13b89$export$f940502e6cd075ee)(options, prefixes, target, targetParent, sensitivity, shine, event);
            });
            targetParent.addEventListener("touchend", function() {
                (0, $0062bc4b3dedcf35$export$c74eda7ed352dc6e)(options, prefixes, target, shine);
            });
        }
    });
}


function $fc7fa3d65d8d13d5$export$3c30105f8ceb23ac(htmlClass) {
    const element = document.querySelector(htmlClass);
    if (element !== null) window.addEventListener("scroll", function() {
        const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
        let opacity = window.scrollY / scrollableHeight;
        element.style.opacity = opacity > 1 ? 1 : opacity;
    });
}


(0, $fc7fa3d65d8d13d5$export$3c30105f8ceb23ac)(".hero__blur");
(0, $376065c23bd29606$export$2d87bb3ac19b3c3b)({
    targets: ".apps__container",
    perspective: 1000,
    sensitivity: 12,
    invert: false,
    scale: 1.1,
    shadow: true,
    shine: true,
    touch: true
});




//# sourceMappingURL=index.d21241a1.js.map
